import { m } from '@hub/messages';
import { Button, Icon } from '@platform/ui';

type Method = 'password' | 'email-code';

interface MethodSelectionProps {
  email: string;
  onSelect: (m: Method) => void;
  onCancel: () => void;
}

export function MethodSelection({ email, onSelect, onCancel }: MethodSelectionProps) {
  return (
    <div className="space-y-4">
      <div className="grid gap-3">
        <button
          type="button"
          onClick={() => onSelect('password')}
          className="flex items-center gap-3 rounded-lg border border-input p-3 text-left transition-colors hover:border-primary hover:bg-accent"
        >
          <Icon name="credentials" className="size-6 shrink-0 text-muted-foreground" />
          <div>
            <p className="font-semibold text-sm">{m.auth_mfa_method_password_title()}</p>
            <p className="text-muted-foreground text-sm">{m.auth_mfa_method_password_description()}</p>
          </div>
        </button>
        <button
          type="button"
          onClick={() => onSelect('email-code')}
          className="flex items-center gap-3 rounded-lg border border-input p-3 text-left transition-colors hover:border-primary hover:bg-accent"
        >
          <Icon name="mail" className="size-6 shrink-0 text-muted-foreground" />
          <div>
            <p className="font-semibold text-sm">{m.auth_mfa_method_email_title()}</p>
            <p className="text-muted-foreground text-sm">{m.auth_mfa_method_email_description({ email })}</p>
          </div>
        </button>
      </div>
      <Button type="button" variant="outline" className="w-full" onClick={onCancel}>
        {m.auth_mfa_cancel_button()}
      </Button>
    </div>
  );
}
